/**
 * AI Assist avatar icon
 * Shown in the chat message avatar for assistant replies.
 */

import type { ReactNode } from 'react';

export function AIAssistAvatarIcon(): ReactNode {
  return (
    <img
      src="/assets/rithm.png"
      alt=""
      style={{ width: '80%', height: '80%', objectFit: 'contain' }}
    />
  );
}
